import Image from 'next/image';
import React, { ReactElement } from 'react';

import { DOWNLOAD_APPLE_CHIP_MAC_URL,DOWNLOAD_INTEL_CHIP_MAC_URL } from '../../constants';
import * as S from './Hero.styles';

export const Hero = (): ReactElement => {
  return (
    <S.Wrapper>
      <S.ContentContainer>
        <S.LeftLogoContainer>
          <Image
            alt={'brain.fm and apple logos'}
            height={40}
            loading="eager"
            objectFit="contain"
            priority
            src={'https://cdn.brain.fm/images/apple+brainfm.svg'}
            width={125}
          />
        </S.LeftLogoContainer>

        <S.LeftTitleContainer>
          <p>
            Download<br />
            Brain.fm Desktop<br />
            for macOS
         </p>
        </S.LeftTitleContainer>

        <S.LeftDescriptionContainer>
          Boost your productivity right from your Mac menu bar.
        </S.LeftDescriptionContainer>

        <S.LeftButtonContainer>
          <S.ButtonContainer>
            <S.Button href={DOWNLOAD_INTEL_CHIP_MAC_URL}>
              <S.ButtonIcon src={'https://cdn.brain.fm/icons/apple-black.svg'} />
              MAC WITH INTEL CHIP
            </S.Button>
            <S.ButtonNote>Mac OS X 10.5+</S.ButtonNote>
          </S.ButtonContainer>

          <S.ButtonContainer>
            <S.Button href={DOWNLOAD_APPLE_CHIP_MAC_URL}>
              <S.ButtonIcon src={'https://cdn.brain.fm/icons/apple-black.svg'} />
              MAC WITH APPLE CHIP
            </S.Button>
            <S.ButtonNote>Mac OS 11+</S.ButtonNote>
          </S.ButtonContainer>
        </S.LeftButtonContainer>

        <S.LeftQuestionContainer>
          Not sure? <a href="https://support.apple.com/en-us/116943"> Find your chip.</a>
        </S.LeftQuestionContainer>
      </S.ContentContainer>

      <S.BackgroundBlur>
        <Image
          alt={'brain.fm background gradient'}
          layout="fill"
          loading="lazy"
          src={'https://cdn.brain.fm/images/download_page_background_blur.webp'}
        />
      </S.BackgroundBlur>
      <S.Background>
        <img
          alt={'brain.fm menu bar app'}
          src={'https://cdn.brain.fm/images/downloads_page_hero_image2.webp'}
          style={{ maxWidth: '1210px' }}
        />
      </S.Background>
    </S.Wrapper>
  );
};
